<div class="datepicker">
  <div class="datepicker-period">
    <span>Período</span>
    <div class="header">
        <span class="left" (click)="toggleCalendar('fromDate')" *ngIf="firstSelectionDay === 0"><span>DE</span></span>
        <span class="right" (click)="toggleCalendar('toDate')" *ngIf="lastSelectionDay === 0"><span>ATÉ</span></span>

      <span class="left" (click)="toggleCalendar('fromDate')"
            [ngClass]="{'selected': showCalendar && fromDateContext}"
            *ngIf="firstSelectionDay !== 0"><span>DE</span> {{firstSelectionDay}} / {{months[firstSelectionMonth]}} / {{firstSelectionYear}}</span>
      <span class="right" (click)="toggleCalendar('toDate')"
            [ngClass]="{'selected': showCalendar && toDateContext}"
            *ngIf="lastSelectionDay !== 0"><span>ATÉ</span> {{lastSelectionDay}} / {{months[lastSelectionMonth].split(0, 2)[0]}} / {{lastSelectionYear}}</span>
    </div>
  </div>
  <div class="datepicker-inner" [ngClass]="showCalendar ? 'show-calendar' : 'hide-calendar'">
      <div class="datepicker-select">
        <span>Selecionar</span>
        <div>
          <span (click)="last7Days()">Últimos 7 dias</span>
          <span (click)="last15Days()">Últimos 15 dias</span>
          <span (click)="currentMonth()">Mês atual</span>
          <span (click)="last3Months()">Últimos 3 meses</span>
          <span (click)="clear()">Limpar</span>
        </div>
      </div>
      <div class="calendar">
        <div class="header">
          <span class="left button" id="prev" (click)="prevMonth($event)"> &lang; </span>
          <span class="month-year" id="label"> {{months[month]}} {{year}} </span>
          <span class="right button" id="next" (click)="nextMonth($event)"> &rang; </span>
        </div>
        <table id="days">
          <td>Dom</td>
          <td>Seg</td>
          <td>Ter</td>
          <td>Qua</td>
          <td>Qui</td>
          <td>Sex</td>
          <td>Sáb</td>
        </table>
        <div class="calendar-frame">
          <table class="curr">
            <tbody>
              <tr *ngFor="let rows of calendarMatrix">
                <td (click)="customSelection($event)" (mouseover)="selectMiddle($event)" *ngFor="let column of rows" [ngClass]="!column ? 'nil' : ''">{{column}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</div>
